import { BotRegion } from '../../../common/enums/bot/bot-region.enum'

export const botRegions = [
  ['Europe (West)', BotRegion.EU_WEST],
  ['US (East)', BotRegion.US_EAST]
]

export const botRegionTooltip = 'By default all bots are created in the EU West region.'
